import FormLogin from "../components/Login/FormLogin/FormLogin";
import Navbar from "../components/Custom/Navbar/Navbar";

export default function Login() {
  return (
    <>
      <Navbar />
      <FormLogin />
    </>
  );
}
